import { render } from "./stipendCourseList.vue?vue&type=template&id=7195fc14&ts=true"
import script from "./stipendCourseList.vue?vue&type=script&lang=ts"
export * from "./stipendCourseList.vue?vue&type=script&lang=ts"

import "./stipendCourseList.vue?vue&type=style&index=0&id=7195fc14&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__